import React from 'react';

type CMSImportPhase =
  | 'uploading'
  | 'replicating'
  | 'ready'
  | 'ingesting'
  | 'completed'
  | 'failed';

interface Props {
  phase: CMSImportPhase | string;
}

const phaseConfig: Record<
  CMSImportPhase,
  { label: string; className: string; showSpinner?: boolean }
> = {
  uploading: {
    label: 'Uploaded',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  },
  replicating: {
    label: 'Processing',
    className:
      'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    showSpinner: true,
  },
  ready: {
    label: 'Ready',
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  },
  ingesting: {
    label: 'Ingesting',
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    showSpinner: true,
  },
  completed: {
    label: 'Completed',
    className:
      'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  },
};

export const CMSImportStatusBadge: React.FC<Props> = ({ phase }) => {
  const config = phaseConfig[phase as CMSImportPhase] ?? {
    label: phase,
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}
    >
      {config.showSpinner && (
        <svg
          className="animate-spin h-3 w-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {config.label}
    </span>
  );
};
